<div class="file-extension-selection">
  <mat-radio-group class="radio-group" aria-labelledby="radio-group-label" [(ngModel)]="filter.fileExtension">
    <mat-radio-button *ngFor="let option of options" [value]="option.type" (change)="onSelectionChange(option.type)">
      {{ option.name }}
    </mat-radio-button>
  </mat-radio-group>
</div>
